import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { StatusBehandeling } from '@common/customControls/bariatrics';
import { getProcessActivityAssetsSchema } from '@common/validation/processActivityAsset';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export type BariPostTreatmentReportData = {
    assets: ProcessActivityAsset[];
    datum_afgerond: string | null;
    doorverwijzing: string | null;
    relatedProcessActivityId: string | null;
    status_behandeling: StatusBehandeling | null;
    toelichting: string | null;
};

export const doorverwijzingOptionExtern = 'Extern doorverwezen';

const bariPostTreatmentReportFinal: TypedSchema<BariPostTreatmentReportData> = {
    assets: getProcessActivityAssetsSchema({ min: 1 }),
    datum_afgerond: Koi.koi().todayOrBefore(),
    doorverwijzing: getTextAreaStringSchema(),
    relatedProcessActivityId: Koi.when('doorverwijzing', {
        is: doorverwijzingOptionExtern,
        otherwise: Koi.string().uuid(),
        then: Koi.valid(null),
    }),
    status_behandeling: Koi.koi().enum(StatusBehandeling),
    toelichting: getTextAreaStringSchema(true),
};

const bariPostTreatmentReportDraft: TypedSchema<BariPostTreatmentReportData> = addAllowNull(
    {
        ...bariPostTreatmentReportFinal,
        assets: getProcessActivityAssetsSchema(),
        relatedProcessActivityId: Koi.when('doorverwijzing', {
            is: doorverwijzingOptionExtern,
            otherwise: Koi.string().uuid().allow(null),
            then: Koi.valid(null),
        }),
    },
    ['assets', 'toelichting']
);

export const bariPostTreatmentReportDraftSchema = Koi.object(bariPostTreatmentReportDraft);
export const bariPostTreatmentReportFinalSchema = Koi.object(bariPostTreatmentReportFinal);

export type BariPostTreatmentReportReadKey = keyof BariPostTreatmentReportData;

export type BariPostTreatmentReportReadLabel =
    | 'Datum afgerond'
    | 'Doorverwijzing'
    | 'Status behandeling'
    | 'Toelichting'
    | 'Verslag';

export const bariPostTreatmentReportReadSchema: TypedReadSchema<
    BariPostTreatmentReportReadKey,
    BariPostTreatmentReportReadLabel
>[] = [
    {
        items: [
            {
                key: 'doorverwijzing',
                label: 'Doorverwijzing',
            },
            {
                key: 'assets',
                label: 'Verslag',
            },
            {
                key: 'datum_afgerond',
                label: 'Datum afgerond',
                type: 'dateAsString',
            },
            {
                key: 'status_behandeling',
                label: 'Status behandeling',
            },
            {
                key: 'toelichting',
                label: 'Toelichting',
            },
        ],
    },
];
